module.exports = "<div class=\"routeContainer\" [@routeAnimation]=\"getDepth(myOutlet)\">\r\n    <router-outlet #myOutlet=\"outlet\"></router-outlet>\r\n</div>"